// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/client/modules/sites/modules/sites-detail/sites-detail.less
// module id = 4008
// module chunks = 0